{
  "dialogs": {
    "assignGroup": {
      "message": "Möchten Sie die Gruppe {name} wirklich den {count} ausgewählten Anmeldeverfahren zuweisen? "
    },
    "assignGroupTemplate": {
      "message": "Möchten Sie die Gruppe {name} wirklich den {count} ausgewählten Vorlagen zuweisen? "
    },
    "deleteGroup": {
      "message": "Möchten Sie das die Gruppe {name} wirklich löschen?<br />Es werden keine Anmeldeverfahren gelöscht."
    },
    "deleteProcedures": {
      "message": "Über die Liste können nur Anmeldeverfahren gelöscht werden, welche nicht veröffentlicht sind und keine Anmeldungen besitzen.<br /><br />Von den ausgewählten Verfahren erfüllen <strong>{count} von {total} Verfahren</strong> diese Voraussetzungen.<br /><br />Möchten Sie diese jetzt löschen?",
      "novalidprocedures": "Über die Liste können zum Schutz vor versehentlichem Löschen nur Anmeldeverfahren gelöscht werden, welche nicht veröffentlicht sind und keine Anmeldungen besitzen. <br /><br />Derzeit haben Sie keine zulässigen Verfahren ausgewählt. Bitte löschen Sie Verfahren mit Anmeldungen direkt aus dem Verfahren heraus."
    },
    "deleteTemplates": {
      "message": "Möchten Sie die ausgewählten {count} Vorlagen wirklich löschen?"
    },
    "deleteTopic": {
      "message": "Möchten Sie das Thema/den Termin {name} wirklich löschen?<br />Hierbei gehen auch alle bisher abgegebenen Bewertungen sowie Zuweisungen verloren."
    },
    "removeGroup": {
      "message": "Möchten Sie alle Gruppenzuweisung der {count} ausgewählten Anmeldeverfahren wirklich entfernen?"
    },
    "removeGroupTemplate": {
      "message": "Möchten Sie alle Gruppenzuweisung der {count} ausgewählten Vorlagen wirklich entfernen?"
    },
    "renewaccessid": {
      "message": "Möchten Sie die Adresse des privaten Zugriffslinks wirklich neu generieren? Die alte Adresse verliert ihre Gültigkeit."
    },
    "toggleVisibility": {
      "message": "Möchten Sie die Sichtbarkeit aller ausgewählten Anmeldeverfahren auf <strong>{visibility}</strong> ändern?"
    }
  },
  "fields": {
    "activity": {
      "type": {
        "values": {
          "BoostActivate": "Boost für Anmeldung aktiviert",
          "BoostDeactivate": "Boost für Anmeldung deaktiviert",
          "FcfsAccept": "FCFS: Platz erhalten",
          "Lottery": "Losverfahren durchgeführt",
          "LotteryAccept": "Platz durch Losverfahren erhalten",
          "ManagerSignupAdd": "{targetUser} wurde durch Verwalter/in angemeldet.",
          "ProcedureAccessChanged": "Zugriffseinstellungen geändert",
          "ProcedureAdd": "Anmeldeverfahren angelegt",
          "ProcedureEdit": "Einstellungen geändert",
          "ProcedureGroupAssigned": "Die Gruppe {description} wurde zugewiesen",
          "ProcedureGroupRemoved": "Die Gruppe {description} wurde entfernt",
          "ProcedureManagerAdded": "Zugriffsrechte an {targetUser} vergeben",
          "ProcedureManagerDeleted": "Zugriffsrechte von {targetUser} entzogen",
          "ProcedureTopicAdded": "Thema {description} hinzugefügt",
          "ProcedureTopicDeleted": "Thema {description} gelöscht",
          "ProcedureTopicOrderChanged": "Themen-Reihenfolge geändert",
          "ProcedureTopicUpdated": "Thema {description} aktualisiert",
          "RenewProcedureAccessId": "Privater Zugriffslink aktualisiert",
          "SignupAdd": "Neue Anmeldung",
          "SignupAddTopic": "Neue Anmeldung (ausgewählt: {description})",
          "SignupConfirmed": "Die Teilnahme wurde bestätigt",
          "SignupEdit": "Anmeldung geändert",
          "SignupJoin": "Lerngruppe beigetreten",
          "SignupRemove": "Abmeldung durchgeführt",
          "SportRankingLottery": "Fachsemester-Ranking Verfahren durchgeführt",
          "SportRankingLotteryAccept": "Platz über Fachsemester-Ranking Verfahren erhalten",
          "StateChange": "Anmeldestatus von Bewerbungen geändert",
          "StateDeclineUnconfirmed": "Das Angebot an {targetUser} wurde nach Fristüberschreitung automatisch abgelehnt.",
          "TemplateAdd": "Neue Vorlage angelegt"
        }
      }
    },
    "group": {
      "allowedBoostCount": {
        "label": "Boosts pro Sem."
      },
      "allowedConfirmationCount": {
        "label": "Max. Bestätigungen pro Sem."
      },
      "allowedRegistrationCount": {
        "label": "Max. Anmeldungen pro Sem."
      },
      "name": {
        "label": "Name"
      },
      "procedureCount": {
        "label": "Verknüpfte Verfahren"
      },
      "shortName": {
        "invalid": "Die Bezeichnung darf nur aus Buchstaben und Zahlen bestehen"
      },
      "shortname": {
        "label": "Kurzbezeichnung"
      },
      "visibility": {
        "label": "Sichtbarkeit",
        "values": {
          "0": {
            "description": "Die Gruppe ist öffentlich sichtbar und kann im Angebot als Filter verwendet werden.",
            "label": "Öffentlich"
          },
          "1": {
            "description": "Die Gruppe wird nicht im Angebot aufgeführt, ist aber in den Details zu Anmeldebeschränkungen sichtbar.",
            "label": "Anzeige von Beschränkungen"
          },
          "2": {
            "description": "Die Gruppe ist nur für die Verwalter/innen sichtbar, nützlich wenn Sie die Gruppe nur für Berechtigungen verwenden.",
            "label": "Versteckt"
          }
        }
      }
    },
    "optimization": {
      "status": {
        "FEASIBLE": "Zulässig 🤔",
        "INFEASIBLE": "Keine Lösung 😞",
        "OPTIMAL": "Optimal 🎉"
      }
    },
    "procedure": {
      "allocationType": {
        "abbr": {
          "FirstComeFirstServed": "FCFS",
          "Lottery": "Losverfahren",
          "Manual": "Manuell",
          "Optimization": "Optimierung",
          "SportRanking": "FS-Ranking"
        },
        "descriptions": {
          "FirstComeFirstServed": "First Come First Served, auch als Windhundverfahren bekannt, vergibt Plätze nach Eingangszeitpunkt der Bewerbung. Um Überbuchungen durch gleichzeitigen Eingang zu vermeiden, legt das System daher alle Anmeldungen zuerst im Status Offen an, und vergibt anschließend verfügbare Plätze nach Reihenfolge in der Datenbank. Dadurch ist sichergestellt, dass Sie nicht plötzlich mit mehr Zusagen als verfügbaren Plätzen konfrontiert werden.<br /><br />In diesem Verfahren wird derzeit keine automatische Vergabe von Themen oder Terminen unterstützt. Sie können jedoch manuell den Zusagen Themen oder Termine zuweisen.<br /><br /><strong>Bitte beachten Sie:</strong> First Come First Served benachteiligt Interessenten, welche zum Anmeldestart zeitlich oder technisch verhindert sind (z.B. Auslandsaufenthalt, Urlaub, ...) erheblich. Bitte überlegen Sie, ob daher ein anderes Verfahren (z.B. Losverfahren) gerade bei hoher Nachfrage nicht ebenso funktionieren würde.",
          "Lottery": "Das Losverfahren nimmt den Zeitdruck aus dem Windhundverfahren/First Come First Served und erlaubt es Interessenten sich innerhalb des Anmeldezeitraums entspannt anzumelden. Zum festgelegten Loszeitpunkt werden die Plätze unter allen eingegangenen Anmeldungen verlost.<br />Bleiben oder werden Plätze frei wird die Verlosung periodisch erneut durchgeführt, um die freien Plätze aus der Warteliste oder zwischenzeitlich eingegangenen Anmeldungen weiter zu besetzen bis das Nachrückende erreicht ist. Dabei werden Personen von der Warteliste (d.h. Teilnehmer eines vorherigen Losverfahrens ohne Zusage) bevorzugt. Ein manueller Eingriff ist nicht notwendig. ",
          "Manual": "In der Anmeldeliste Ihres Verfahren finden Sie alle eingegangenen Anmeldungen. Dort können entweder über das Hinzufügen der Spalten oder die Detailansicht die erfolgten Themenbewertungen (falls vorhanden) und gemachten Angaben (falls abgefragt) eingesehen werden. Anschließend können Sie über die Status- und Themen-Dropdowns (Ansicht 1) oder die Status- und Themenbuttons (Ansicht 2) eine Auswahl treffen und entscheiden, ob Teilnehmer ein Teilnahme-Angebot (muss bestätigt werden) oder eine Zusage (muss nicht mehr bestätigt werden) erhalten. Es kann auch der Status Warteliste verwendet werden um potentielle Nachrücker zu informieren, allerdings erfolgt kein automatisches Nachrücken.<br /><br />Durch Speichern der Änderungen werden die Statusänderungen wirksam und Studierende informiert. Bei Absage/nicht fristgerechter Bestätigung durch Studierende werden alle eingetragenen Dozierenden per E-Mail über den freigewordenen Platz benachrichtigt. Eine automatische Nachbesetzung erfolgt nicht.",
          "Optimization": "Bei der optimalen Verteilung müssen alle Bewerber eine Bewertung von Themen, Terminen oder Veranstaltungen bei der Anmeldung abgeben. Nach Ende des Anmeldezeitraums können Sie dann die optimale Verteilung ausführen. Hierbei wird lineare Optimierung genutzt, um alle (oder falls das Platzangebot nicht genügt: möglichst viele) Anmeldungen nach der jeweiligen Präferenz auf die verfügbaren Themen/Termine zu verteilen.<br /><br /> Dieses Verfahren versucht die Gesamtzufriedenheit, welches die durchschnittliche Zufriedenheit mit der Terminzuweisung jedes einzelnen Teilnehmers, zu maximieren.<br /><br />Nach der Optimierung sehen Sie wie die Verteilung und Zufriedenheit aussieht und können ggf. Anpassungen an den verfügbaren Plätzen vornehmen.",
          "SportRanking": "Dieses Verfahren nutzt eine Rangliste (basierende auf Fachsemester, Regelstudienzeit und Loszahl bei Gleichstand) um freie Plätze zu vergeben. Hierbei werden Plätze initial durch die Rangliste, anschließend durch die Warteliste und neue Anmeldungen erneut durch eine Ranglistenberechnung vergeben."
        },
        "explanations": {
          "FirstComeFirstServed": "Die Plätze werden automatisch nach Eingangszeitpunkt vergeben.",
          "Lottery": "Zum Loszeitpunkt werden die Plätze unter allen eingegangenen Anmeldungen verlost.",
          "Manual": "Der oder die Dozierende trifft eine Teilnehmerauswahl.",
          "Optimization": "Die Plätze und Zuweisungen werden anhand der abgegebenen Bewertungen optimal verteilt.",
          "SportRanking": "Die Plätze werden nach einem Rankingverfahren auf Basis des Fachsemesters und der Regelstudienzeit vergeben."
        },
        "label": "Vergabeverfahren",
        "managerhints": {
          "FirstComeFirstServed": "Auch bekannt als Windhundprinzip werden die Plätze hier nach Eingangszeitpunkt der Bewerbung vergeben. Dies ist für Bewerber bei beliebten Veranstaltungen oft mit erheblichen Nachteilen verbunden.",
          "Lottery": "Zu einem von Ihnen festlegten Zeitpunkt werden unter allen Bewerbern die verfügbaren Plätze verlost. Ein Nachrücken erfolgt dann nach dem Windhundprinzip.",
          "Manual": "Sie können in der Teilnehmerliste Zusagen und Absagen vergeben. Hierbei können Sie die bei der Anmeldung hinterlegten Angaben berücksichtigen.",
          "Optimization": "Alle Bewerber werden anhand ihrer Präferenzen auf eine Menge von Terminen, Themen oder Veranstaltungen optimal verteilt.",
          "SportRanking": "Bildet zum angegebenen Zeitpunkt eine Rangliste basierend auf dem Fachsemester und der Regelstudienzeit und vergibt die Plätze nach dieser. In der Nachrückphase werden die Plätze nach der Rangliste und weitere Plätze nach Verlosung vergeben."
        },
        "recommendations": {
          "FirstComeFirstServed": "Veranstaltungen mit begrenzter oder unbegrenzter Platzzahl und mittlerer Nachfrage, z.B. Klausureinsichten.",
          "Lottery": "Veranstaltungen mit begrenzter Platzzahl und oftmals großer Nachfrage, z.B. Seminare oder Sprachkurse.",
          "Manual": "Seminare oder kleine Veranstaltungen bei denen Sie möglichst passende Teilnehmer finden möchten.",
          "Optimization": "Große Veranstaltungen, bei denen eine Vielzahl von Terminen oder Themen zur Verfügung steht und Sie die die Interessenten möglichst optimal verteilen möchten, z.B. Tutorien.",
          "SportRanking": "Veranstaltungen, in welchen Studierende in höheren Fachsemestern bevorzugt werden sollen."
        },
        "values": {
          "FirstComeFirstServed": "First Come First Served",
          "Lottery": "Losverfahren",
          "Manual": "Manuelle Auswahl",
          "Optimization": "Optimierte Verteilung",
          "SportRanking": "Fachsemester-Ranking"
        }
      },
      "closingDate": "Nachrückende",
      "eventType": {
        "label": "Art der Veranstaltung",
        "values": {
          "BonusExam": "Bonusklausur",
          "Exam": "Prüfung",
          "Lecture": "Vorlesung",
          "Other": "Anderes",
          "Practical": "Praktikum",
          "Review": "Klausureinsicht",
          "Seminar": "Seminar",
          "Tutorial": "Tutorium",
          "Workshop": "Tagesworkshop"
        }
      },
      "firstDrawDate": "Nächste geplante Verlosung",
      "questions": {
        "types": {
          "0": "Textfeld (einzeilig)",
          "1": "Textfeld (mehrzeilig)",
          "2": "Zahlenangabe",
          "3": "Dateiupload (PDF)",
          "4": "Auswahl (einfach)",
          "5": "Auswahl (mehrfach)"
        }
      },
      "registrationEnd": "Anmeldeende",
      "registrationStart": "Anmeldebeginn",
      "restrictionDegree": {
        "values": {
          "1": "Bachelor",
          "2": "Master",
          "4": "Diplom",
          "8": "Zeitstudium"
        }
      },
      "restrictionUserType": {
        "values": {
          "1": "Externe Personen",
          "2": "Studierende (KIT)",
          "4": "Gäste & Partner",
          "8": "Mitarbeitende"
        }
      },
      "studyGroupSize": "Lerngruppengröße",
      "visibility": {
        "label": "Sichtbarkeit",
        "values": {
          "None": "Unveröffentlicht",
          "Private": "Privat",
          "Public": "Öffentlich"
        }
      }
    },
    "proceduretopic": {
      "dayOfWeek": {
        "label": "Wochentag",
        "values": {
          "Friday": {
            "long": "Freitag",
            "short": "Fr"
          },
          "Monday": {
            "long": "Montag",
            "short": "Mo"
          },
          "Saturday": {
            "long": "Samstag",
            "short": "Sa"
          },
          "Sunday": {
            "long": "Sonntag",
            "short": "So"
          },
          "Thursday": {
            "long": "Donnerstag",
            "short": "Do"
          },
          "Tuesday": {
            "long": "Dienstag",
            "short": "Di"
          },
          "Wednesday": {
            "long": "Mittwoch",
            "short": "Mi"
          }
        }
      },
      "type": {
        "label": "Typ",
        "values": {
          "Event": "Veranstaltung",
          "SingleAppointment": "Einzel-Termin",
          "Topic": "Thema",
          "WeeklyAppointment": "Wöchentl. Termin"
        }
      }
    },
    "registration": {
      "state": {
        "details": {
          "accepted": "Sie haben für die Veranstaltung eine Zusage erhalten und dürfen an der Veranstaltung teilnehmen. Bitte melden Sie sich rechtzeitig ab, falls Sie an der Veranstaltung nicht teilnehmen können.",
          "declined": "Leider konnte Ihnen für diese Veranstaltung kein Platz angeboten werden.",
          "offer": "Sie haben ein Teilnahmeangebot für diese Veranstaltung erhalten. Die Teilnahme muss innerhalb der angegeben Frist bestätigt werden, andersfalls verfällt das Angebot.",
          "open": "Ihre Anmeldung ist eingegangen, bisher liegt noch keine Entscheidung über eine Teilnahme vor. Bei einigen Vergabeverfahren erfolgt die Platzvergabe zu einem gemeinsamen Zeitpunkt.",
          "waitlist": "Sie befinden sich auf der Warteliste für diese Veranstaltung. Sollten Plätze frei werden, werden diese aus der Warteliste nachbesetzt."
        },
        "values": {
          "0": "Offen",
          "1": "Warteliste",
          "2": "Angebot",
          "3": "Zusage",
          "4": "Absage",
          "accepted": "Zusage",
          "declined": "Absage",
          "offer": "Angebot",
          "open": "Offen",
          "waitlist": "Warteliste"
        }
      }
    }
  },
  "import": {
    "errors": {
      "duplicateprocedure": "Es existiert bereits ein Anmeldeverfahren mit identischen Einstellungen, jedoch hat dieser Eintrag noch keine Id und würde doppelt angelegt werden. Haben Sie evtl. eine alte Liste verwendet?",
      "invalidfield": {
        "campusEventId": "Zur angegebenen VL-Nummer existiert keine Veranstaltung oder Sie haben keinen Zugriff auf diese Veranstaltung",
        "closingdate": "Das Nachrückende darf nicht vor dem Anmeldeende liegen",
        "eventtype": "Die angegebene Art der Veranstaltung ist ungültig",
        "group": "Das angegebene Gruppenkürzel existiert nicht oder Sie haben keinen Zugriff",
        "heading": "Es wurde keine Überschrift angegeben oder die Überschrift ist ungültig",
        "id": "Die angegebene Id existiert nicht oder Sie besitzen keinen vollen Zugriff auf dieses Verfahren",
        "name": "Es muss ein Name für das Verfahren angegeben werden",
        "primarycontactmail": "Es muss eine Kontakt-E-Mail-Adresse angegeben werden",
        "registrationend": "Das Anmeldeende muss angegeben werden und nach dem Anmeldebeginn liegen",
        "registrationstart": "Der Anmeldebeginn muss angegeben werden"
      },
      "missingfield": {
        "name": "Das Feld Name muss ausgefüllt werden."
      }
    }
  },
  "labels": {
    "allocationType": "Vergabe",
    "assignedTopic": "Thema/Termin",
    "biweekly": "zweiwöchentl.",
    "createdOn": "Anmeldung",
    "currently": "derzeit",
    "deadline": "Frist",
    "degrees": "Abschlüsse",
    "firstdrawdate": "Los-/Vergabezeitpunkt",
    "group": "Gruppe",
    "groups": "Gruppen",
    "happiness": "Zufriedenheit",
    "place": "Platz",
    "registration": "Anmeldung",
    "removefavorite": "Favorit entfernen",
    "resetFilters": "Alle Filter zurücksetzen",
    "star": "Stern",
    "stars": "Sterne",
    "state": "Status",
    "title": "Titel",
    "type": "Art",
    "unit": "Einrichtung",
    "unlimited": "unbeschränkt",
    "usage": "Belegung",
    "visibility": "Sichtb.",
    "weekly": "wöchentl."
  },
  "list": {
    "labels": {
      "group": "Veranstaltungsgruppe",
      "heading": "Einordnung im Vorlesungsverzeichnis",
      "offering": "Angebot",
      "refresh": "Aktualisieren",
      "showDifferentTerm": "Laufende Anmeldeverfahren aus anderen Semestern anzeigen",
      "showEndedProcedures": "Beendete Verfahren anzeigen"
    },
    "messages": {
      "noresults": "Es wurden leider keine Veranstaltungen mit den ausgewählten Parametern gefunden.",
      "notloggedinwarning": "Sie sind nicht eingeloggt. Möglicherweise sehen Sie nicht alle verfügbaren Veranstaltungen. Bitte melden Sie sich zur Veranstaltungsanmeldung über den Button oben rechts mit Ihrem KIT-Login oder als externer Nutzer an."
    }
  },
  "menu": {
    "labels": {
      "campusvvztree": "Campus VVZ Baum",
      "manage": "Verwalten",
      "myregistrations": "Meine Anmeldungen",
      "offering": "Angebot"
    }
  },
  "myregistrations": {
    "boostintro": "Eine oder mehrere Ihrer Anmeldungen erlauben die Vergabe von Boosts 🚀, um diese Anmeldungen zu priorisieren und die Chance auf einen Platz zu erhöhen.",
    "boostsdoc": "Weitere Informationen zu Boosts",
    "confirmparticipation": "Teilnahme bestätigen",
    "confirmparticipationerror": {
      "deadlinepassed": "Die Frist zur Bestätigung der Teilnahme ist abgelaufen.",
      "grouplimitexceeded": "Sie haben die maximale Anzahl an Teilnahmebestätigungen innerhalb der folgenden Gruppe(n) erreicht. Sie müssen sich zuerst von einer anderen Veranstaltung innerhalb dieser Gruppe abmelden, um die Teilnahme für diese Veranstaltung bestätigen zu können.",
      "intro": "Eine Teilnahmebestätigung ist nicht möglich",
      "notfound": "Die gewünschte Anmeldung wurde nicht gefunden.",
      "unauthorized": "Sie sind nicht berechtigt, die Teilnahme für diese Anmeldung zu bestätigen."
    },
    "confirmparticipationmessage": "Möchten Sie die Teilnahme an der Veranstaltung <strong>{0}</strong> bestätigen?",
    "confirmparticipationmessageext": "<br />Dies gilt auch für die Mitglieder Ihrer Lerngruppe.",
    "emptylist": "In diesem Semester liegen noch keine Anmeldungen von Ihnen vor. Schauen Sie doch einfach mal ins",
    "pendingoffer": "Sie haben ein Teilnahmeangebot für diese Veranstaltung. Sie müssen die Teilnahme bis {0} bestätigen, um Ihren Platz nicht zu verlieren.",
    "unregister": {
      "accepted": "Sie haben derzeit eine Zusage, welche durch die Abmeldung erlischt.",
      "button_yes": "Ja, Abmelden",
      "founder": "Sie sind der Gründer dieser Lerngruppe. Durch die Abmeldung wird ein anderes Mitglied der Lerngruppe Gründer.",
      "intro": "Möchten Sie sich von der oben genannten Veranstaltung wirklich abmelden?",
      "offer": "Sie haben derzeit ein Teilnahmeangebot, welches durch die Abmeldung erlischt.",
      "reregisternotpossible": "Eine neue Anmeldung ist nicht mehr möglich, da der Anmeldezeitraum abgelaufen ist.",
      "reregisterpossible": "Eine neue Anmeldung ist möglich, solange der Anmeldezeitraum noch läuft.",
      "title": "Abmeldung",
      "waitlist": "Sie befinden sich derzeit auf der Warteliste. Durch die Abmeldung verlieren Sie Ihren Wartelistenplatz."
    }
  },
  "notifications": {
    "campusvvz": {
      "guidcopied": "Die GUID für die Überschrift {0} wurde in die Zwischenablage kopiert."
    },
    "exportilias": {
      "loading": "Der Export wird durchgeführt. Abhängig von der Teilnehmeranzahl kann dies bis zu mehrere Minuten dauern. Sie werden informiert, wenn der Export abgeschlossen ist."
    },
    "group": {
      "copied": "Der Link zum Angebot für die Gruppe {0} wurde in die Zwischenablage kopiert.",
      "create": {
        "success": "Die Gruppe wurde erfolgreich angelegt"
      },
      "edit": {
        "error": "Es ist ein allgemeiner Fehler aufgetreten. Bitte kontaktieren Sie den Support.",
        "notallowed": "Sie sind nicht berechtigt, diese Gruppe zu bearbeiten",
        "notfound": "Die zu bearbeitende Gruppe existiert nicht mehr",
        "shortnameconflict": "Die angegebene Kurzbezeichnung wird bereits für eine andere Gruppe verwendet"
      },
      "update": {
        "success": "Die Gruppe wurde aktualisiert"
      }
    },
    "iliasexport": {
      "error": "Beim Export ist leider ein Fehler aufgetreten. Sie können den Export erneut versuchen oder sich an Support wenden."
    },
    "iliasvalidation": {
      "error": "Beim Überprüfen der ILIAS Konfiguration ist ein Fehler aufgetreten."
    },
    "procedure": {
      "allocationrun": {
        "success": "Die Vergabeprozesse wurden für die ausgewählten Verfahren gestartet. Es kann einige Minuten dauern bis alle Prozesse durchgelaufen sind."
      },
      "autosave": {
        "error": "Beim automatischen Speichern ist ein Fehler aufgetreten."
      },
      "deleted": {
        "success": "Die ausgewählten, zulässigen Anmeldeverfahren wurden gelöscht"
      },
      "duplicate": {
        "error": "Beim Kopieren ist ein allgemeiner Fehler aufgetreten. Bitte wenden Sie sich bei Fragen an den Support.",
        "notallowed": "Sie sind nicht berechtigt, das Verfahren zu kopieren.",
        "notfound": "Das angegebene Verfahren wurde nicht gefunden.",
        "success": "Das Verfahren wurde erfolgreich kopiert."
      },
      "edit": {
        "error": "Es ist ein allgemeines Problem beim Aufruf des Anmeldeverfahrens aufgetreten.",
        "notallowed": "Sie sind nicht berechtigt, dieses Verfahren zu bearbeiten.",
        "notfound": "Das angegebene Verfahren existiert nicht."
      },
      "fakeRegistrationsCreated": "Testbewerbungen wurden erfolgreich erzeugt",
      "group": {
        "assign": {
          "success": "Die Gruppe wurden den ausgewählten Anmeldeverfahren zugewiesen"
        },
        "delete": {
          "success": "Die Gruppe {name} wurde gelöscht"
        },
        "remove": {
          "success": "Die Gruppenzuweisungen wurden entfernt"
        }
      },
      "join": {
        "success": "Sie sind der Lerngruppe erfolgreich beigetreten und finden diese in der Liste Ihrer Anmeldungen."
      },
      "manager": {
        "add": {
          "alreadyexists": "Die Person ist bereits in der Liste der zugriffsberechtigten Personen enthalten",
          "badrequest": "Die Person konnte nicht hinzugefügt werden",
          "failed": "Beim Hinzufügen ist ein allgemeiner Fehler aufgetreten.",
          "notallowed": "Sie sind nicht berechtigt Personen zu diesem Verfahren hinzuzufügen",
          "notfound": "Die Person oder das Verfahren wurde nicht gefunden",
          "success": "Die Person wurde erfolgreich hinzugefügt"
        },
        "delete": {
          "badrequest": "Beim Löschen der Zugriffsberechtigung ist ein Fehler aufgetreten",
          "failed": "Das Entfernen der Zugriffsberechtigung ist fehlgeschlagen.",
          "notallowed": "Sie sind nicht berechtigt, den Zugriff für diese Person zu entfernen",
          "notfound": "Die angegebene Person konnte nicht als zugriffsberechtigte Person gefunden werden. Möglicherweise wurde sie bereits entfernt.",
          "success": "Zugriffsrechte wurden entfernt"
        },
        "register": {
          "success": "Die ausgewählte Person wurde erfolgreich zum Verfahren angemeldet."
        }
      },
      "optimize": {
        "failure": "Es konnte keine Lösung ermittelt werden. Evtl. sind die verfügbaren Plätze  nicht ausreichend.",
        "success": "Die Optimierung war erfolgreich."
      },
      "register": {
        "alreadyregistered": "Sie sind bereits für diese Veranstaltung angemeldet. Sie finden Ihre Anmeldung unter \"Meine Anmeldungen\".",
        "badrequest": "Ihre Anmeldung konnte nicht gespeichert werden. Bitte stellen Sie sicher, dass alle verpflichtenden Angaben vollständig sind.",
        "confirm": {
          "error": "Beim Bestätigen der Teilnahme ist ein Fehler aufgetreten. Bitte wenden Sie sich im Zweifel an den Support.",
          "limitreached": "Die maximale Anzahl Teilnahmebestätigungen in der dazugehörigen Gruppe wurde bereits erreicht. Eine weitere Bestätigung ist erst möglich, wenn eine Abmeldung von einer anderen Veranstaltung erfolgt ist.",
          "notallowed": "Sie sind nicht berechtigt, eine Bestätigung der Teilnahme durchzuführen.",
          "notfound": "Die angegebene Anmeldung wurde nicht gefunden.",
          "notpossible": "Eine Bestätigung der Anmeldung ist nicht möglich. Entweder befindet sich diese nicht im korrekten Status oder die Bestätigungsfrist ist abgelaufen.",
          "success": "Sie haben Ihre Teilnahme an der Veranstaltung erfolgreich bestätigt"
        },
        "edit": {
          "success": "Ihre Änderungen wurden erfolgreich gespeichert"
        },
        "error": "Beim Speichern der Anmeldung ist ein unbekannter Fehler aufgetreten. Bitte konktaktieren Sie ggf. den Support.",
        "manager": {
          "alreadyregistered": "Der ausgewählte Benutzer ist für dieses Verfahren bereits angemeldet"
        },
        "notallowed": "Eine Anmeldung zu dieser Veranstaltung ist für Sie leider nicht möglich.",
        "notfound": "Die Veranstaltung wurde nicht gefunden oder zwischenzeitlich gelöscht.",
        "notloggedin": "Sie sind nicht angemeldet. Um eine Veranstaltungsanmeldung durchzuführen müssen Sie sich mit Ihrem KIT-Account einloggen oder als externe Person registrieren und anmelden.",
        "remove": {
          "error": "Bei der Abmeldung ist ein allgemeiner Fehler aufgetreten. Bitte versuchen Sie es später erneut.",
          "notallowed": "Sie sind nicht berechtigt, diese Anmeldung zu verwalten.",
          "notfound": "Die Anmeldung wurde nicht gefunden.",
          "success": "Sie wurden erfolgreich im System von der Veranstaltung abgemeldet."
        },
        "success": "Sie haben sich erfolgreich für die Veranstaltung angemeldet und Ihre Anmeldung befindet sich jetzt im Status \"Offen\".",
        "topicfull": "Das ausgewählte Thema/Termin/Veranstaltung ist bereits voll."
      },
      "registeredit": {
        "notallowed": "Ein Bearbeiten der Anmeldung ist nicht länger erlaubt. Entweder ist der Anmeldezeitraum abgelaufen oder die Anmeldung befindet sich in einem Zustand, welcher das Bearbeiten nicht zulässt."
      },
      "registrations": {
        "custommessage": {
          "error": "Beim Versenden der Nachricht ist ein Fehler aufgetreten",
          "success": "Ihre Nachricht wurde erfolgreich versendet"
        },
        "delete": {
          "error": "Beim Löschen der Bewerbungen ist ein Fehler aufgetreten",
          "success": "Es wurden alle Bewerbungen gelöscht."
        },
        "update": {
          "success": "Ihre Anmeldestatusänderungen wurden erfolgreich gespeichert."
        }
      },
      "renewaccessid": {
        "success": "Der private Zugriffslink wurde erneuert"
      },
      "save": {
        "error": "Beim Speichern ist ein Fehler aufgetreten.",
        "success": "Die Änderungen wurden gespeichert"
      },
      "topic": {
        "create": {
          "success": "Das Thema/der Termin {name} wurde erfolgreich angelegt"
        },
        "createassistant": {
          "success": "Die gewünschten Termine wurden erfolgreich angelegt"
        },
        "delete": {
          "success": "Das Thema {name} wurde erfolgreich gelöscht. "
        },
        "update": {
          "success": "Das Thema/der Termin {name} wurde erfolglich aktualisiert"
        }
      }
    },
    "registration": {
      "error": "Beim Abrufen der Anmeldung ist ein allgemeiner Fehler aufgetreten. Bitte kontaktieren Sie bei Fragen den Support.",
      "notallowed": "Sie sind nicht berechtigt, auf diese Anmeldung zuzugreifen.",
      "notfound": "Die gewünschte Anmeldung konnte nicht gefunden werden. Möglicherweise wurde sie zwischenzeitlich gelöscht."
    },
    "template": {
      "convert": {
        "success": "Die Vorlage wurde erfolgreich erstellt"
      },
      "group": {
        "assign": {
          "success": "Die Gruppe wurden den ausgewählten Vorlagen zugewiesen"
        },
        "delete": {
          "success": "Die Gruppe {name} wurde gelöscht"
        },
        "remove": {
          "success": "Die Gruppenzuweisungen wurden entfernt"
        }
      }
    },
    "topic": {
      "error": {
        "fetch": "Beim Abruf der Themen und Termine ist ein Fehler aufgetreten."
      },
      "order": {
        "start": "Sortieren Sie die Themen über Drag&Drop"
      }
    }
  },
  "procedure": {
    "labels": {
      "restrictionDegree": "Abschlüsse",
      "restrictionProducts": "Studiengänge",
      "restrictionUserType": "Persongruppen"
    },
    "registrations": {
      "addregistration": "Anmeldung hinzufügen",
      "campuscompare": "Campus Teilnehmer-Vergleich",
      "declineopen": "Offenen Bewerbungen absagen",
      "labels": {
        "createdon": "Eingang",
        "overbooking": "Überbuchung",
        "points": "Punkte",
        "registrationlist": "Anmeldeliste",
        "regstatus": "Anmeldestatus",
        "topicapp": "Thema/Termin",
        "topicplaces": "Themenplätze",
        "waitlistplace": "Wartelistenplatz"
      },
      "showstudygroupnames": "Namen der Lerngruppenmitglieder anzeigen",
      "stickyview": "Tabellenkopf anheften",
      "texts": {
        "declineopentextcount": "Sie haben <strong>{0} Bewerbungen</strong> im Status Offen.<br /><br />Möchten Sie diese auf abgelehnt setzen? Die Änderungen werden erst wirksam, wenn Sie diese im Anschluss über Anwenden veröffentlichen.",
        "discardchangestext": "Sie haben Änderungen vorgenommen, die nicht gespeichert wurden. Wollen Sie diese verwerfen?",
        "discardchangestextcount": "Sie haben <strong>{0} unveröffentlichte Änderungen</strong>.<br />Möchten Sie diese wirklich verwerfen? Dabei werden alle Änderungen auf den derzeit veröffentlichten Stand zurückgesetzt.",
        "discardchangestitle": "Änderungen verwerfen?",
        "publishchangestitle": "Änderungen veröffentlichen",
        "savechangestextcount": "Sie haben <strong>{0} ausstehende Änderungen</strong>.<br />Möchten Sie diese nun veröffentlichen?<br /><br /><em>Die betroffenen Personen werden über ihre neue Status-Zuweisung per E-Mail informiert.</em>",
        "savechangestitle": "Änderungen speichern"
      },
      "viewbuttons": "Button-Darstellung",
      "viewextcharts": "Erweiterte Belegungsanzeige",
      "viewextended": "Erweiterte Angaben"
    }
  },
  "procedureview": {
    "availableplaces": "Verfügbare Plätze ",
    "conflict": "Terminkonflikt",
    "contact": "Kontakt-Adresse zu dieser Veranstaltung",
    "contactdesc": "Bei Fragen zu dieser Veranstaltung oder zur Anmeldung wenden Sie sich bitte an die o.g. E-Mail-Adresse.",
    "groupintro": "Diese Veranstaltung ist Teil der Gruppe",
    "grouplimitboosttext": "In dieser Gruppe können Boosts vergeben werden, um die Gewichtung der Anmeldung zu erhöhen",
    "grouplimitconfirmationtext": "Innerhalb dieser Gruppe ist die Anzahl der möglichen Teilnahmebestätigungen pro Semester begrenzt",
    "grouplimitother": "Alle nicht explizit aufgeführten Studiengänge",
    "grouplimits": {
      "boostsingular": "Boost",
      "boostsplural": "Boosts",
      "confirmationplural": "Teilnahmebestätigungen",
      "confirmationsingular": "Teilnahmebestätigung",
      "noboosts": "Keine Boosts erlaubt",
      "noconfirmation": "Keine Teilnahmebestätigung möglich",
      "nolimit": "keine Beschränkung",
      "noregistration": "keine Anmeldung möglich",
      "registrationplural": "Anmeldungen",
      "registrationsingular": "Anmeldung"
    },
    "grouplimittext": "Innerhalb dieser Gruppe ist die Anzahl der möglichen Anmeldungen pro Semester begrenzt",
    "groupshortname": "Kürzel",
    "headings": {
      "additionalInformation": "Weitere Informationen",
      "group": "Gruppe",
      "registrationandallocation": "Anmeldung und Platzvergabe",
      "requiredinformation": "Angaben während der Anmeldung",
      "restrictions": "Beschränkungen",
      "studygroup": "Lerngruppe",
      "topicsappointmentsevents": "Themen, Termine und Veranstaltungen",
      "topicselection": "Ausgewähltes Thema/Termin/Veranstaltung"
    },
    "linkedcampusevent": "Zugehörige Campus-Veranstaltung",
    "note": "Inhalt",
    "notloggedinwarning": "Sie sind nicht angemeldet. Bitte loggen Sie sich oben rechts ein, um sich für diese Veranstaltung anzumelden.",
    "registrationlimited": "Die Anmeldung zu dieser Veranstaltung ist beschränkt auf:",
    "registrationperiod": "Anmeldezeitraum",
    "requiredinformation": "Während der Anmeldung müssen Sie die folgenden Angaben machen",
    "studygroupfounder": "Gründer",
    "studygroupintro": "Diese Veranstaltung erlaubt Lerngruppen mit bis zu {0} Mitgliedern. Alle Mitglieder erhalten den gleichen Status sowie die gleiche Themen-, Termin- bzw Veranstaltungszuweisung.",
    "studygrouplink": "Beitrittslink zu Ihrer Lerngruppe",
    "studygrouplinkintro": "Sie können weitere Personen zu Ihrer Lerngruppe einladen, indem Sie den folgenden Link weitergeben",
    "studygroupmemberlist": "Derzeit besitzt diese Anmeldung die folgenden Mitglieder",
    "studygroupsizedesc": "bis zu {0} Mitglieder",
    "taepresent": "Zu dieser Veranstaltungen wurden folgende Themen, Termine oder Veranstaltungen eingetragen, welche Sie zusammen mit einer Zusage zugewiesen bekommen können.",
    "taeratingrequired": "Während der Anmeldung müssen Sie für diese eine Bewertung abgeben.",
    "yourrating": "Ihre Bewertung",
    "yourregstatus": "Ihr Anmeldestatus",
    "yourresponse": "Ihre Antwort",
    "yourresponses": "Ihre Antworten",
    "yourtopic": "Ihr Thema/Termin/Veranstaltung",
    "yourtopicassignment": "Sie haben dieses Thema/diesen Termin/diese Veranstaltung erhalten!",
    "yourtopicselection": "Sie haben dieses Thema/diesen Termin/diese Veranstaltung ausgewählt.",
    "yourupload": "Ihr hochgeladenes Dokument"
  },
  "registration": {
    "add": {
      "backtooffering": "Zurück zum Angebot",
      "degreesallowed": "Zugelassene Abschlüsse",
      "degreesyou": "Ihre aktiven Abschlüsse",
      "enableautoupdate": "Platzaktualisierung aktivieren",
      "error": {
        "heading": "Anmeldung nicht möglich",
        "intro": "Leider ist eine Anmeldung für Sie nicht möglich:",
        "productnoreg": "Für Ihren Studiengang ist keine Anmeldung möglich.",
        "regconditional": "Anmeldung nur unter Vorbehalt möglich",
        "regconditionaltext": "Eine Anmeldung zu dieser Veranstaltung ist für Sie aus den unten genannten Gründen nur unter Vorbehalt möglich. Der Veranstalter hat zugelassen, dass eine Anmeldung auch bei Nichterfüllung der Voraussetzungen möglich ist, eine Teilnahme kann jedoch nachträglich ausgeschlossen werden. Bitte stellen Sie sicher, dass Sie an der Veranstaltung teilnehmen dürfen."
      },
      "intro": "Sie haben sich erfolgreich angemeldet.",
      "newregistration": "Neue Anmeldung",
      "noautoupdate": "Sie waren zu lange inaktiv. Um die automatische Aktualisierung der verfügbaren Plätze wieder zu aktivieren, klicken Sie bitte hier",
      "nofreeplaces": "Keine freien Plätze",
      "notice": "Bitte beachten Sie, dass eine Anmeldung keinen Anspruch auf Teilnahme darstellt.",
      "notificationnotice": "Sie erhalten vom System eine automatische Anmeldebestätigung mit dem aktuellen Status sowie weitere E-Mails bei Statusänderungen. Den aktuellen Status finden Sie jederzeit unter \"Meine Anmeldungen\".",
      "productsallowed": "Zugelassene Studiengänge",
      "productsyou": "Ihre aktiven Studiengänge",
      "registernow": "Jetzt anmelden",
      "regsperterm": "Anmeldungen pro Semester",
      "title": "Anmeldung erfolgreich",
      "usergroupallowed": "Zugelassene Personengruppen",
      "usergroupyou": "Ihre Personengruppe"
    },
    "buttons": {
      "edit": "Bearbeiten",
      "registrationadd": "Neue Anmeldung",
      "registrationedit": "Anmeldung bearbeiten",
      "registrationgoto": "Zur Anmeldung",
      "registrationview": "Anmeldung ansehen",
      "view": "Ansehen"
    },
    "errors": {
      "alreadyended": "Der Anmeldezeitraum für die Veranstaltung ist abgelaufen.",
      "alreadyregistered": "Sie sind für diese Veranstaltung bereits angemeldet.",
      "cannotjoinfullprocedure": "Ein Beitritt zu einer Anmeldung in einem Zusage-Status ist nur möglich, wenn in der Veranstaltung noch freie Plätze existieren. Sie können sich eigenständig anmelden und in der Warteliste auf einen verfügbaren Platz warten.",
      "cannotjoinfulltopic": "Ein Beitritt zu einer Anmeldung in einem Zusage-Status ist nur möglich, wenn in dem gewählten Thema, Termin oder Veranstaltung noch freie Plätze existieren. Sie können sich eigenständig anmelden und in der Warteliste auf einen verfügbaren Platz warten.",
      "grouplimitreached": "Sie haben die maximal zulässige Anzahl an Anmeldungen in einer der zugewiesenen Veranstaltungsgruppen erreicht.",
      "invaliddegree": "Die Anmeldung ist nur für einige Abschlüsse zulässig. Sie besitzen derzeit keinen Studiengang in einem der zugelassenen Abschlüsse.",
      "invalidproduct": "Die Anmeldung ist nur für spezifische Studiengänge zulässig. Derzeit sind Sie in keinem der zulässigen Studiengänge immatrikuliert.",
      "invalidstate": "Die Anmeldung befindet sich in einem Status, der keinen weiteren Beitritt zur Lerngruppe erlaubt.",
      "invalidusertype": "Sie gehören nicht zu den für diese Veranstaltung zugelassenen Personengruppen.",
      "notstarted": "Der Anmeldezeitraum hat noch nicht begonnen.",
      "studygroupfull": "Die Lerngruppe hat die maximale Teilnehmerzahl erreicht."
    },
    "headings": {
      "masterdata": "Stammdaten",
      "ratings": "Bewertungen",
      "requestedinformation": "Weitere Angaben",
      "topicselection": "Auswahl von Themen, Terminen oder Veranstaltungen"
    },
    "join": {
      "error": {
        "intro": "Leider ist ein Beitritt zur angegebenen Lerngruppe für Sie nicht möglich",
        "title": "Beitritt nicht möglich"
      },
      "intro": "Sie sind im Begriff einer Lerngruppe für die o.g. Veranstaltung beizutreten.<br /> Mitglieder einer Lerngruppe erhalten immer den gleichen Status (Warteliste/Zusage/Absage) und ggf. die gleiche Themen- oder Termin-Zuweisung.<br /> Diese Lerngruppe wurde von <strong>{0}</strong> erstellt.",
      "joinnow": "Jetzt beitreten",
      "joinregistration": "Anmeldung beitreten",
      "ratingintro": "Um sich anzumelden müssen Sie die folgenden Themen, Termine bzw. Veranstaltungen mit 1-5 Sternen bewertet werden. Die unten stehende Bewertung wurde durch den Gründer der Lerngruppe vorgegeben und gilt für alle Teilnehmer",
      "state": "Die Anmeldung befindet sich aktuell im Status: "
    },
    "labels": {
      "gotooffering": "Zum Angebot",
      "mandatory": "Pflicht",
      "namematno": "Name und Matrikelnummer",
      "optional": "Optional",
      "productterm": "Studiengang und Fachsemester (im Veranstaltungssemester)",
      "usergroup": "Personengruppe"
    },
    "texts": {
      "masterdataintro": "Die folgenden Angaben werden dem Veranstalter automatisch bereitgestellt. Mit der Anmeldung erklären Sie sich damit einverstanden, dass diese Daten zum Zweck der Anmeldung gespeichert und an den Veranstalter weitergegeben werden.",
      "noowner": "Kein Besitzer",
      "ratingcountsintro": "Sie müssen mindestens die folgenden Bewertungen abgeben",
      "ratingcountsmax": "max. {0}x (derzeit: {1})",
      "ratingcountsmin": "min. {0}x (noch {1})",
      "ratingcountsminmax": "{0}-{1}x (derzeit: {2})",
      "ratingcountsminmaxsame": "genau {0}x (derzeit: {1})",
      "ratingcountsminok": "min. {0}x",
      "ratingcountsnone": "keine Bewertung zulässig (derzeit: {0})",
      "ratingcountsoverflow": "Bewertungen über die geforderten Grenzen hinaus werden für das Erfüllen niedrigerer Anforderungen verwendet.",
      "ratingcountsremaining": "noch {0}",
      "ratingincomplete": "Ihre Anmeldung erfüllt noch nicht alle Anforderungen an die Bewertung.",
      "ratingintro": "Um sich anzumelden müssen Sie die folgenden Themen, Termine bzw. Veranstaltungen mit 1-5 Sternen bewerten.",
      "ratingrequireallrated": "Es müssen alle Themen bewertet werden",
      "ratingrequireaverage": "Durchschnittsbewertung <strong>mind. {0} Sterne</strong> (derzeit: {1})",
      "ratingrequireequalpct": "<strong>Maximal {0}%</strong> der Themen dürfen gleich bewertet werden (derzeit: {1}%)",
      "ratingrequirementintro": "Die abzugebenden Bewertungen müssen folgende Anforderungen erfüllen",
      "requestedinformationincomplete": "Es wurden noch nicht alle Pflichtangaben ausgefüllt.",
      "selectionincomplete": "Es muss ein Thema, Termin bzw. eine Veranstaltung ausgewählt werden.",
      "selectionintro": "Für die Anmeldung müssen Sie aus der unten stehenden Liste genau ein Thema bzw. einen Termin oder eine Veranstaltung auswählen, an welchem bzw. welcher Sie interessiert sind. Bei der Platzvergabe wird anhand Ihrer Auswahl eine Entscheidung über ein Platzangebot bzw. eine Zusage getroffen.",
      "selectionwaitlist": "Die Warteliste für bereits gefüllte Themen oder Termine ist aktiviert. Sie können sich auf ein Thema, Termin oder eine Veranstaltung anmelden, auf welchem/r bereits alle Plätze vergeben sind und erhalten eine Zusage, wenn dort ein Platz frei wird. Sie sehen die gesamte Anzahl angemeldeter Personen (inkl. bisheriger Warteliste).",
      "studygroupmemberintro": "Sie sind Mitglied einer Lerngruppe für diese Anmeldung. Die Anmeldung kann nur durch den Gründer der Lerngruppe ({0}) bearbeitet werden."
    }
  },
  "rms": {
  },
  "stats": {
    "titles": {
      "deadlineCounts": "Aktuell ausstehende Bestätigungsfristen",
      "degreeCounts": "Verteilung der Anmeldungen auf Abschlüsse",
      "productCounts": "Verteilung der Anmeldungen auf Studiengänge",
      "registrationTimeCounts": "Eingang der Anmeldungen",
      "stateCounts": "Verteilung des Anmeldestatus ",
      "topProcedures": "Anmeldeverfahren mit den meisten Anmeldungen"
    }
  },
  "texts": {
    "createnewprocedure": "Neues Anmeldeverfahren anlegen",
    "createnewtemplate": "Neue Vorlage anlegen",
    "editprocedure": "Einstellungen",
    "exportilias": {
      "noAccess": "Sie sind nicht berechtigt auf den ILIAS Kurs zuzugreifen",
      "noCampusEvent": "Es ist keine Campus-Veranstaltung hinterlegt",
      "noIliasCourse": "Es gibt keinen ILIAS Kurs zur angegeben Campus-Veranstaltung"
    },
    "group": {
      "create": "Gruppe anlegen"
    },
    "groups": {
      "access": "Gruppenzugriff verwalten",
      "edit": "Gruppe bearbeiten"
    },
    "perterm": "pro Semester",
    "topics": {
      "assistant": "Termin-Assistent",
      "editevent": "Veranstaltung bearbeiten",
      "editsingleappointment": "Einzel-Termin bearbeiten",
      "edittopic": "Thema bearbeiten",
      "editweeklyappointment": "Wöchentl. Termin bearbeiten",
      "newevent": "Veranstaltung hinzufügen",
      "newsingleappointment": "Neuen Einzel-Termin anlegen",
      "newtopic": "Neues Thema anlegen",
      "newweeklyappointment": "Neuer wöchentl. Termin"
    }
  }
}
